// AUTO-GENERATED from '4.1. SCST_School_Result_10&12_SC_ST.xlsx'
const SCHOOL_RESULTS = {
  "10_adw": {
    "state": {
      "schools": 206,
      "appeared": 6193,
      "passed": 5662,
      "failed": 531,
      "pass_pct": 91.43,
      "male_pass_pct": 89.32,
      "female_pass_pct": 94.07
    },
    "districts": {
      "ARIYALUR": {
        "schools": 3,
        "appeared": 57,
        "passed": 50,
        "failed": 7,
        "pass_pct": 87.72,
        "male_pass_pct": 82.56,
        "female_pass_pct": 93.98
      },
      "CHENGALPATTU": {
        "schools": 12,
        "appeared": 698,
        "passed": 582,
        "failed": 116,
        "pass_pct": 83.38,
        "male_pass_pct": 80.73,
        "female_pass_pct": 88.14
      },
      "CHENNAI": {
        "schools": 10,
        "appeared": 387,
        "passed": 331,
        "failed": 56,
        "pass_pct": 85.53,
        "male_pass_pct": 84.29,
        "female_pass_pct": 90.41
      },
      "COIMBATORE": {
        "schools": 3,
        "appeared": 69,
        "passed": 65,
        "failed": 4,
        "pass_pct": 94.2,
        "male_pass_pct": 88.11,
        "female_pass_pct": 100.0
      },
      "CUDDALORE": {
        "schools": 14,
        "appeared": 514,
        "passed": 483,
        "failed": 31,
        "pass_pct": 93.97,
        "male_pass_pct": 91.89,
        "female_pass_pct": 97.35
      },
      "DHARMAPURI": {
        "schools": 1,
        "appeared": 40,
        "passed": 35,
        "failed": 5,
        "pass_pct": 87.5,
        "male_pass_pct": 75.0,
        "female_pass_pct": 95.83
      },
      "DINDIGUL": {
        "schools": 3,
        "appeared": 44,
        "passed": 42,
        "failed": 2,
        "pass_pct": 95.45,
        "male_pass_pct": 100.0,
        "female_pass_pct": 86.82
      },
      "KALLAKURICHI": {
        "schools": 3,
        "appeared": 113,
        "passed": 103,
        "failed": 10,
        "pass_pct": 91.15,
        "male_pass_pct": 91.11,
        "female_pass_pct": 91.74
      },
      "KANCHEEPURAM": {
        "schools": 6,
        "appeared": 264,
        "passed": 258,
        "failed": 6,
        "pass_pct": 97.73,
        "male_pass_pct": 95.45,
        "female_pass_pct": 100.0
      },
      "KANNIYAKUMARI": {
        "schools": 2,
        "appeared": 25,
        "passed": 25,
        "failed": 0,
        "pass_pct": 100.0,
        "male_pass_pct": 100.0,
        "female_pass_pct": 100.0
      },
      "KARUR": {
        "schools": 8,
        "appeared": 168,
        "passed": 149,
        "failed": 19,
        "pass_pct": 88.69,
        "male_pass_pct": 86.27,
        "female_pass_pct": 91.77
      },
      "KRISHNAGIRI": {
        "schools": 1,
        "appeared": 19,
        "passed": 18,
        "failed": 1,
        "pass_pct": 94.74,
        "male_pass_pct": 100.0,
        "female_pass_pct": 91.67
      },
      "MADURAI": {
        "schools": 6,
        "appeared": 123,
        "passed": 115,
        "failed": 8,
        "pass_pct": 93.5,
        "male_pass_pct": 87.54,
        "female_pass_pct": 98.46
      },
      "MAYILADUTHURAI": {
        "schools": 3,
        "appeared": 80,
        "passed": 75,
        "failed": 5,
        "pass_pct": 93.75,
        "male_pass_pct": 93.94,
        "female_pass_pct": 95.29
      },
      "NAGAPATTINAM": {
        "schools": 2,
        "appeared": 35,
        "passed": 32,
        "failed": 3,
        "pass_pct": 91.43,
        "male_pass_pct": 100.0,
        "female_pass_pct": 86.02
      },
      "NAMAKKAL": {
        "schools": 2,
        "appeared": 80,
        "passed": 73,
        "failed": 7,
        "pass_pct": 91.25,
        "male_pass_pct": 82.9,
        "female_pass_pct": 97.77
      },
      "THE NILGIRIS": {
        "schools": 1,
        "appeared": 10,
        "passed": 10,
        "failed": 0,
        "pass_pct": 100.0,
        "male_pass_pct": 100.0,
        "female_pass_pct": 100.0
      },
      "PERAMBALUR": {
        "schools": 9,
        "appeared": 135,
        "passed": 125,
        "failed": 10,
        "pass_pct": 92.59,
        "male_pass_pct": 88.35,
        "female_pass_pct": 96.91
      },
      "PUDUKKOTTAI": {
        "schools": 3,
        "appeared": 97,
        "passed": 94,
        "failed": 3,
        "pass_pct": 96.91,
        "male_pass_pct": 96.11,
        "female_pass_pct": 97.81
      },
      "RAMANATHAPURAM": {
        "schools": 4,
        "appeared": 48,
        "passed": 47,
        "failed": 1,
        "pass_pct": 97.92,
        "male_pass_pct": 93.62,
        "female_pass_pct": 100.0
      },
      "RANIPET": {
        "schools": 7,
        "appeared": 202,
        "passed": 162,
        "failed": 40,
        "pass_pct": 80.2,
        "male_pass_pct": 76.31,
        "female_pass_pct": 85.89
      },
      "SALEM": {
        "schools": 4,
        "appeared": 122,
        "passed": 105,
        "failed": 17,
        "pass_pct": 86.07,
        "male_pass_pct": 81.87,
        "female_pass_pct": 90.6
      },
      "SIVAGANGAI": {
        "schools": 3,
        "appeared": 68,
        "passed": 68,
        "failed": 0,
        "pass_pct": 100.0,
        "male_pass_pct": 100.0,
        "female_pass_pct": 100.0
      },
      "TENKASI": {
        "schools": 1,
        "appeared": 18,
        "passed": 18,
        "failed": 0,
        "pass_pct": 100.0,
        "male_pass_pct": 100.0,
        "female_pass_pct": 100.0
      },
      "THANJAVUR": {
        "schools": 10,
        "appeared": 271,
        "passed": 264,
        "failed": 7,
        "pass_pct": 97.42,
        "male_pass_pct": 97.33,
        "female_pass_pct": 98.02
      },
      "THENI": {
        "schools": 3,
        "appeared": 67,
        "passed": 62,
        "failed": 5,
        "pass_pct": 92.54,
        "male_pass_pct": 88.49,
        "female_pass_pct": 97.16
      },
      "TIRUNELVELI": {
        "schools": 5,
        "appeared": 127,
        "passed": 116,
        "failed": 11,
        "pass_pct": 91.34,
        "male_pass_pct": 80.37,
        "female_pass_pct": 100.0
      },
      "TIRUPATHUR": {
        "schools": 2,
        "appeared": 42,
        "passed": 36,
        "failed": 6,
        "pass_pct": 85.71,
        "male_pass_pct": 80.61,
        "female_pass_pct": 93.88
      },
      "TIRUPPUR": {
        "schools": 2,
        "appeared": 54,
        "passed": 52,
        "failed": 2,
        "pass_pct": 96.3,
        "male_pass_pct": 100.0,
        "female_pass_pct": 93.73
      },
      "TIRUVALLUR": {
        "schools": 12,
        "appeared": 435,
        "passed": 412,
        "failed": 23,
        "pass_pct": 94.71,
        "male_pass_pct": 93.3,
        "female_pass_pct": 95.92
      },
      "TIRUVANNAMALAI": {
        "schools": 6,
        "appeared": 107,
        "passed": 102,
        "failed": 5,
        "pass_pct": 95.33,
        "male_pass_pct": 93.81,
        "female_pass_pct": 96.53
      },
      "TIRUVARUR": {
        "schools": 4,
        "appeared": 148,
        "passed": 125,
        "failed": 23,
        "pass_pct": 84.46,
        "male_pass_pct": 81.63,
        "female_pass_pct": 89.44
      },
      "TIRUCHIRAPPALLI": {
        "schools": 27,
        "appeared": 776,
        "passed": 743,
        "failed": 33,
        "pass_pct": 95.75,
        "male_pass_pct": 94.2,
        "female_pass_pct": 97.14
      },
      "THOOTHUKKUDI": {
        "schools": 2,
        "appeared": 19,
        "passed": 18,
        "failed": 1,
        "pass_pct": 94.74,
        "male_pass_pct": 90.98,
        "female_pass_pct": 100.0
      },
      "VELLORE": {
        "schools": 10,
        "appeared": 348,
        "passed": 328,
        "failed": 20,
        "pass_pct": 94.25,
        "male_pass_pct": 93.66,
        "female_pass_pct": 95.27
      },
      "VILLUPURAM": {
        "schools": 8,
        "appeared": 298,
        "passed": 258,
        "failed": 40,
        "pass_pct": 86.58,
        "male_pass_pct": 86.45,
        "female_pass_pct": 86.9
      },
      "VIRUDHUNAGAR": {
        "schools": 4,
        "appeared": 85,
        "passed": 81,
        "failed": 4,
        "pass_pct": 95.29,
        "male_pass_pct": 95.69,
        "female_pass_pct": 94.82
      }
    }
  },
  "12_adw": {
    "state": {
      "schools": 98,
      "appeared": 4562,
      "passed": 4130,
      "failed": 432,
      "pass_pct": 90.53,
      "male_pass_pct": 88.48,
      "female_pass_pct": 93.07
    },
    "districts": {
      "ARIYALUR": {
        "schools": 2,
        "appeared": 65,
        "passed": 56,
        "failed": 9,
        "pass_pct": 86.15,
        "male_pass_pct": 77.69,
        "female_pass_pct": 94.91
      },
      "CHENGALPATTU": {
        "schools": 8,
        "appeared": 526,
        "passed": 480,
        "failed": 46,
        "pass_pct": 91.25,
        "male_pass_pct": 88.5,
        "female_pass_pct": 94.09
      },
      "CHENNAI": {
        "schools": 4,
        "appeared": 376,
        "passed": 319,
        "failed": 57,
        "pass_pct": 84.84,
        "male_pass_pct": 84.1,
        "female_pass_pct": 89.71
      },
      "COIMBATORE": {
        "schools": 2,
        "appeared": 37,
        "passed": 34,
        "failed": 3,
        "pass_pct": 91.89,
        "male_pass_pct": 96.1,
        "female_pass_pct": 82.43
      },
      "CUDDALORE": {
        "schools": 11,
        "appeared": 549,
        "passed": 532,
        "failed": 17,
        "pass_pct": 96.9,
        "male_pass_pct": 95.97,
        "female_pass_pct": 96.12
      },
      "DHARMAPURI": {
        "schools": 1,
        "appeared": 39,
        "passed": 34,
        "failed": 5,
        "pass_pct": 87.18,
        "male_pass_pct": 90.91,
        "female_pass_pct": 82.35
      },
      "DINDIGUL": {
        "schools": 2,
        "appeared": 39,
        "passed": 39,
        "failed": 0,
        "pass_pct": 100.0,
        "male_pass_pct": 100.0,
        "female_pass_pct": 100.0
      },
      "KANCHEEPURAM": {
        "schools": 2,
        "appeared": 111,
        "passed": 107,
        "failed": 4,
        "pass_pct": 96.4,
        "male_pass_pct": 100.0,
        "female_pass_pct": 92.79
      },
      "KANNIYAKUMARI": {
        "schools": 2,
        "appeared": 31,
        "passed": 27,
        "failed": 4,
        "pass_pct": 87.1,
        "male_pass_pct": 85.25,
        "female_pass_pct": 88.89
      },
      "KARUR": {
        "schools": 3,
        "appeared": 107,
        "passed": 102,
        "failed": 5,
        "pass_pct": 95.33,
        "male_pass_pct": 93.99,
        "female_pass_pct": 97.01
      },
      "KRISHNAGIRI": {
        "schools": 1,
        "appeared": 29,
        "passed": 24,
        "failed": 5,
        "pass_pct": 82.76,
        "male_pass_pct": 83.33,
        "female_pass_pct": 82.35
      },
      "MADURAI": {
        "schools": 3,
        "appeared": 79,
        "passed": 75,
        "failed": 4,
        "pass_pct": 94.94,
        "male_pass_pct": 93.23,
        "female_pass_pct": 97.35
      },
      "MAYILADUTHURAI": {
        "schools": 3,
        "appeared": 91,
        "passed": 84,
        "failed": 7,
        "pass_pct": 92.31,
        "male_pass_pct": 85.88,
        "female_pass_pct": 96.89
      },
      "NAMAKKAL": {
        "schools": 1,
        "appeared": 78,
        "passed": 75,
        "failed": 3,
        "pass_pct": 96.15,
        "male_pass_pct": 90.91,
        "female_pass_pct": 100.0
      },
      "PERAMBALUR": {
        "schools": 2,
        "appeared": 36,
        "passed": 26,
        "failed": 10,
        "pass_pct": 72.22,
        "male_pass_pct": 68.18,
        "female_pass_pct": 80.0
      },
      "PUDUKKOTTAI": {
        "schools": 1,
        "appeared": 67,
        "passed": 65,
        "failed": 2,
        "pass_pct": 97.01,
        "male_pass_pct": 96.43,
        "female_pass_pct": 97.44
      },
      "RANIPET": {
        "schools": 3,
        "appeared": 175,
        "passed": 149,
        "failed": 26,
        "pass_pct": 85.14,
        "male_pass_pct": 72.53,
        "female_pass_pct": 90.2
      },
      "SALEM": {
        "schools": 2,
        "appeared": 92,
        "passed": 89,
        "failed": 3,
        "pass_pct": 96.74,
        "male_pass_pct": 95.11,
        "female_pass_pct": 98.19
      },
      "SIVAGANGAI": {
        "schools": 1,
        "appeared": 32,
        "passed": 32,
        "failed": 0,
        "pass_pct": 100.0,
        "male_pass_pct": 100.0,
        "female_pass_pct": 100.0
      },
      "THANJAVUR": {
        "schools": 3,
        "appeared": 102,
        "passed": 100,
        "failed": 2,
        "pass_pct": 98.04,
        "male_pass_pct": 96.82,
        "female_pass_pct": 100.0
      },
      "THENI": {
        "schools": 2,
        "appeared": 74,
        "passed": 67,
        "failed": 7,
        "pass_pct": 90.54,
        "male_pass_pct": 85.95,
        "female_pass_pct": 97.35
      },
      "TIRUNELVELI": {
        "schools": 4,
        "appeared": 94,
        "passed": 88,
        "failed": 6,
        "pass_pct": 93.62,
        "male_pass_pct": 89.52,
        "female_pass_pct": 98.63
      },
      "TIRUPATHUR": {
        "schools": 1,
        "appeared": 31,
        "passed": 28,
        "failed": 3,
        "pass_pct": 90.32,
        "male_pass_pct": 90.0,
        "female_pass_pct": 90.91
      },
      "TIRUVALLUR": {
        "schools": 6,
        "appeared": 355,
        "passed": 310,
        "failed": 45,
        "pass_pct": 87.32,
        "male_pass_pct": 82.62,
        "female_pass_pct": 92.49
      },
      "TIRUVARUR": {
        "schools": 3,
        "appeared": 131,
        "passed": 86,
        "failed": 45,
        "pass_pct": 65.65,
        "male_pass_pct": 66.76,
        "female_pass_pct": 64.21
      },
      "TRICHY": {
        "schools": 13,
        "appeared": 695,
        "passed": 660,
        "failed": 35,
        "pass_pct": 94.96,
        "male_pass_pct": 93.52,
        "female_pass_pct": 98.35
      },
      "VELLORE": {
        "schools": 5,
        "appeared": 249,
        "passed": 231,
        "failed": 18,
        "pass_pct": 92.77,
        "male_pass_pct": 90.87,
        "female_pass_pct": 95.93
      },
      "VILLUPURAM": {
        "schools": 5,
        "appeared": 231,
        "passed": 175,
        "failed": 56,
        "pass_pct": 75.76,
        "male_pass_pct": 73.81,
        "female_pass_pct": 78.84
      },
      "VIRUDHUNAGAR": {
        "schools": 2,
        "appeared": 41,
        "passed": 36,
        "failed": 5,
        "pass_pct": 87.8,
        "male_pass_pct": 81.42,
        "female_pass_pct": 100.0
      }
    }
  },
  "10_tw": {
    "state": {
      "schools": 67,
      "appeared": 2245,
      "passed": 2170,
      "failed": 75,
      "pass_pct": 96.66,
      "male_pass_pct": 96.56,
      "female_pass_pct": 96.56
    },
    "districts": {
      "CHENGALPATTU": {
        "schools": 1,
        "appeared": 33,
        "passed": 33,
        "failed": 0,
        "pass_pct": 100.0,
        "male_pass_pct": 100.0,
        "female_pass_pct": 100.0
      },
      "COIMBATORE": {
        "schools": 3,
        "appeared": 85,
        "passed": 85,
        "failed": 0,
        "pass_pct": 100.0,
        "male_pass_pct": 100.0,
        "female_pass_pct": 100.0
      },
      "DHARMAPURI": {
        "schools": 5,
        "appeared": 145,
        "passed": 140,
        "failed": 5,
        "pass_pct": 96.55,
        "male_pass_pct": 91.38,
        "female_pass_pct": 100.0
      },
      "DINDIGUL": {
        "schools": 1,
        "appeared": 23,
        "passed": 23,
        "failed": 0,
        "pass_pct": 100.0,
        "male_pass_pct": 100.0,
        "female_pass_pct": 100.0
      },
      "ERODE": {
        "schools": 5,
        "appeared": 136,
        "passed": 123,
        "failed": 13,
        "pass_pct": 90.44,
        "male_pass_pct": 91.26,
        "female_pass_pct": 87.72
      },
      "KALLAKURICHI": {
        "schools": 9,
        "appeared": 401,
        "passed": 377,
        "failed": 24,
        "pass_pct": 94.01,
        "male_pass_pct": 94.49,
        "female_pass_pct": 94.5
      },
      "KANNIYAKUMARI": {
        "schools": 3,
        "appeared": 69,
        "passed": 68,
        "failed": 1,
        "pass_pct": 98.55,
        "male_pass_pct": 100.0,
        "female_pass_pct": 97.1
      },
      "NAMAKKAL": {
        "schools": 5,
        "appeared": 282,
        "passed": 271,
        "failed": 11,
        "pass_pct": 96.1,
        "male_pass_pct": 96.4,
        "female_pass_pct": 96.44
      },
      "THE NILGIRIS": {
        "schools": 6,
        "appeared": 194,
        "passed": 180,
        "failed": 14,
        "pass_pct": 92.78,
        "male_pass_pct": 94.7,
        "female_pass_pct": 89.76
      },
      "PERAMBALUR": {
        "schools": 1,
        "appeared": 13,
        "passed": 13,
        "failed": 0,
        "pass_pct": 100.0,
        "male_pass_pct": 100.0,
        "female_pass_pct": 100.0
      },
      "SALEM": {
        "schools": 16,
        "appeared": 537,
        "passed": 532,
        "failed": 5,
        "pass_pct": 99.07,
        "male_pass_pct": 98.63,
        "female_pass_pct": 99.1
      },
      "TIRUNELVELI": {
        "schools": 1,
        "appeared": 2,
        "passed": 2,
        "failed": 0,
        "pass_pct": 100.0,
        "male_pass_pct": 100.0,
        "female_pass_pct": 100.0
      },
      "TIRUPATHUR": {
        "schools": 1,
        "appeared": 46,
        "passed": 46,
        "failed": 0,
        "pass_pct": 100.0,
        "male_pass_pct": 100.0,
        "female_pass_pct": 100.0
      },
      "TIRUVANNAMALAI": {
        "schools": 7,
        "appeared": 198,
        "passed": 196,
        "failed": 2,
        "pass_pct": 98.99,
        "male_pass_pct": 99.07,
        "female_pass_pct": 99.12
      },
      "TIRUCHIRAPPALLI": {
        "schools": 3,
        "appeared": 81,
        "passed": 81,
        "failed": 0,
        "pass_pct": 100.0,
        "male_pass_pct": 100.0,
        "female_pass_pct": 100.0
      }
    }
  },
  "12_tw": {
    "state": {
      "schools": 36,
      "appeared": 1463,
      "passed": 1424,
      "failed": 39,
      "pass_pct": 97.33,
      "male_pass_pct": 96.71,
      "female_pass_pct": 97.72
    },
    "districts": {
      "CHENGALPATTU": {
        "schools": 1,
        "appeared": 17,
        "passed": 16,
        "failed": 1,
        "pass_pct": 94.12,
        "male_pass_pct": 100.0,
        "female_pass_pct": 83.33
      },
      "COIMBATORE": {
        "schools": 1,
        "appeared": 37,
        "passed": 37,
        "failed": 0,
        "pass_pct": 100.0,
        "male_pass_pct": 100.0,
        "female_pass_pct": 100.0
      },
      "DHARMAPURI": {
        "schools": 3,
        "appeared": 101,
        "passed": 99,
        "failed": 2,
        "pass_pct": 98.02,
        "male_pass_pct": 94.97,
        "female_pass_pct": 100.0
      },
      "DINDIGUL": {
        "schools": 1,
        "appeared": 19,
        "passed": 18,
        "failed": 1,
        "pass_pct": 94.74,
        "male_pass_pct": 100.0,
        "female_pass_pct": 85.71
      },
      "ERODE": {
        "schools": 2,
        "appeared": 79,
        "passed": 78,
        "failed": 1,
        "pass_pct": 98.73,
        "male_pass_pct": 100.0,
        "female_pass_pct": 97.69
      },
      "KALLAKURICHI": {
        "schools": 5,
        "appeared": 216,
        "passed": 205,
        "failed": 11,
        "pass_pct": 94.91,
        "male_pass_pct": 94.44,
        "female_pass_pct": 95.7
      },
      "KANNIYAKUMARI": {
        "schools": 2,
        "appeared": 86,
        "passed": 85,
        "failed": 1,
        "pass_pct": 98.84,
        "male_pass_pct": 97.47,
        "female_pass_pct": 100.0
      },
      "NAMAKKAL": {
        "schools": 5,
        "appeared": 300,
        "passed": 287,
        "failed": 13,
        "pass_pct": 95.67,
        "male_pass_pct": 93.8,
        "female_pass_pct": 96.02
      },
      "THE NILGIRIS": {
        "schools": 3,
        "appeared": 107,
        "passed": 104,
        "failed": 3,
        "pass_pct": 97.2,
        "male_pass_pct": 98.05,
        "female_pass_pct": 96.42
      },
      "SALEM": {
        "schools": 6,
        "appeared": 306,
        "passed": 300,
        "failed": 6,
        "pass_pct": 98.04,
        "male_pass_pct": 96.63,
        "female_pass_pct": 99.11
      },
      "TIRUPATHUR": {
        "schools": 1,
        "appeared": 35,
        "passed": 35,
        "failed": 0,
        "pass_pct": 100.0,
        "male_pass_pct": 100.0,
        "female_pass_pct": 100.0
      },
      "TIRUVANNAMALAI": {
        "schools": 4,
        "appeared": 99,
        "passed": 99,
        "failed": 0,
        "pass_pct": 100.0,
        "male_pass_pct": 100.0,
        "female_pass_pct": 100.0
      },
      "TRICHY": {
        "schools": 2,
        "appeared": 61,
        "passed": 61,
        "failed": 0,
        "pass_pct": 100.0,
        "male_pass_pct": 100.0,
        "female_pass_pct": 100.0
      }
    }
  }
};

export default SCHOOL_RESULTS;
